import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Forces the app language to English.
 * Used in Arc Mosaico signup pages (TeacherSignup, StudentSignup).
 */
export const useForceEnglish = () => {
  const { i18n } = useTranslation()

  useEffect(() => {
    if (i18n.language !== 'en') {
      i18n.changeLanguage('en')
    }
  }, [i18n.language])
}
